import React, { useEffect } from 'react';

const ChatWidget = () => {
  useEffect(() => {
    // This code runs once the component mounts
    const widgetElement = document.createElement('charla-widget');
    widgetElement.setAttribute("p", "7b19dc3c-f7c8-45a6-bd67-a0be0cd7c87d");
    document.body.appendChild(widgetElement);
    
    const widgetCode = document.createElement('script');
    widgetCode.src = 'https://app.getcharla.com/widget/widget.js';
    document.body.appendChild(widgetCode);

    // Clean up when the component is unmounted (if needed)
    return () => {
      document.body.removeChild(widgetElement);
      document.body.removeChild(widgetCode);
    };
  }, []); // Empty dependency array ensures this runs once when the component mounts

  return null; // This component doesn't need to render anything
};

export default ChatWidget;
